// This is more for the redux dev tool
// See https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#actionsanitizer--statesanitizer
import { dataTableActionTypes } from './ducks/playersAndTeams/dataTable';

const actionSanitizer = (action) => {
    if (action.type === dataTableActionTypes.FETCH_DATA_SUCCESS && action.payload.dataset) {
        return {
            type: action.type,
            payload: {
                dataset: '<<LONG_BLOB>>',
            },
        };
    }
    return action;
};

const stateSanitizer = (state) => {
    if (state.playersAndTeams.dataTable.dataset) {
        const clone = JSON.parse(JSON.stringify(state));
        clone.playersAndTeams.dataTable.dataset = '<<DATA>>';
        return clone;
    }
    return state;
};

export { actionSanitizer, stateSanitizer };
